import { FC } from 'react';
import useSportsbookTopbarAnimation from './sportsbook-use-top-bar-animation';
import { useSelector } from 'react-redux';
import { selectHasRegulationsHeader } from '../../../../header/regulations-header';
import { isNativeNavHeaderEnabled } from '~/components/app-bridge/app-properties';
import styled from 'styled-components';
import { motion } from 'motion/react';
import { sizes } from '../../../../../utils/style-utils';

const hasNativeHeaders = isNativeNavHeaderEnabled();

type WrapperProps = {
	hasRegulationsHeader: boolean;
	hasNativeHeaders: boolean;
};

const Wrapper = styled(motion.div)<WrapperProps>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 12px;
	gap: 12px;
	margin-bottom: -2px; // Because pills have additional padding to it (4px), need to adjust gap between this component and content below.

	transition: background-color 0.2s ease-out;
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
	background-color: rgba(var(--sportsbook-top-bar-bg-color), 0.75);

	position: sticky;
	z-index: 1;
	left: 0;
	right: 0;
	top: ${props =>
		props.hasRegulationsHeader
			? `calc(var(--regulationHeight) + var(--smallerHeaderHeight))`
			: props.hasNativeHeaders
				? `0`
				: `var(--smallerHeaderHeight)`};

	@media (min-width: ${sizes.lg}px) {
		// use margin-top to account for a value of margin on pill. Need to align with other content on page.
		margin-top: -2px;
		padding: 0;

		border-bottom-left-radius: var(--sportsbook-rounded-lg);
		border-bottom-right-radius: var(--sportsbook-rounded-lg);
		top: ${({ hasRegulationsHeader }) =>
			hasRegulationsHeader
				? `calc(var(--headerHeight) + var(--subHeaderHeight) + var(--regulationHeight))`
				: `calc(var(--headerHeight) + var(--subHeaderHeight))`};
	}
`;

type Props = {
	children: React.ReactNode;
};

const SportsbookTopbarWrapper: FC<Props> = ({ children }) => {
	const hasRegulationsHeader = useSelector(selectHasRegulationsHeader);
	const animationStyles = useSportsbookTopbarAnimation();

	return (
		<Wrapper
			style={animationStyles}
			hasRegulationsHeader={hasRegulationsHeader}
			hasNativeHeaders={hasNativeHeaders}
		>
			{children}
		</Wrapper>
	);
};

export default SportsbookTopbarWrapper;
